import * as React from 'react';
import { ProjectId, AssetId, getAsset, setIsComplete, setAnnouncement } from 'owa-timestream-store';
import {
    markTodoComplete,
    markTodoIncomplete,
    spacesTodoActionTelemetryData,
} from 'owa-timestream-asset-sdk-tasks';
import loc from 'owa-localize';
import {
    itemMarkedAssetCompletedAnnouncement,
    itemMarkedAssetIncompleteAnnouncement,
} from '../dueDates.locstring.json';

export default function useSetIsComplete(projectId: ProjectId, assetId: AssetId) {
    const setIsCompleteHook: (isComplete: boolean) => void = React.useMemo(
        () => setIsCompleteAndUpdateTask.bind(null, projectId, assetId),
        [projectId, assetId]
    );
    return setIsCompleteHook;
}

function setIsCompleteAndUpdateTask(
    projectId: ProjectId,
    assetId: AssetId,
    isCompleteUpdated: boolean
) {
    setIsComplete(projectId, assetId, isCompleteUpdated);

    const { taskId } = getAsset(projectId, assetId);
    if (taskId) {
        setAnnouncement(
            loc(
                isCompleteUpdated
                    ? itemMarkedAssetCompletedAnnouncement
                    : itemMarkedAssetIncompleteAnnouncement
            )
        );
        isCompleteUpdated
            ? markTodoComplete(taskId, spacesTodoActionTelemetryData)
            : markTodoIncomplete(taskId, spacesTodoActionTelemetryData);
    }
}
